import {
  faAbstractGenerator,
  faTitleGenerator,
  faTransformAi,
} from '@awesome.me/kit-9c96a1f097/icons/kit/custom'
import { faGraduationCap, faHouse } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import AbstractGenerator from '@ui/pages/AbstractGenerator'
import Academizer from '@ui/pages/Academizer'
import GPTDetector from '@ui/pages/GPTDetector'
import Home from '@ui/pages/Home'
import Paraphraser from '@ui/pages/Paraphraser'
import TitleGenerator from '@ui/pages/TitleGenerator'

import { NonVisiblePage, Page } from '../domain/page'

export default function usePages() {
  const features: Page[] = [
    {
      name: 'Title Generator',
      title: 'Get a title to honor your paper.',
      subtitle:
        "Writefull's Title Generator processes your abstract and generates a suitable title.",
      path: '/title-generator',
      icon: <FontAwesomeIcon icon={faTitleGenerator} size='xl' />,
      element: <TitleGenerator />,
    },
    {
      name: 'Abstract Generator',
      title: 'Get your abstract written.',
      subtitle:
        "Writefull's Abstract Generator gives you an abstract based on your paper's content.",
      path: '/abstract-generator',
      icon: <FontAwesomeIcon icon={faAbstractGenerator} size='xl' />,
      element: <AbstractGenerator />,
    },
    {
      name: 'Paraphraser',
      title: 'Paraphrasing tool.',
      subtitle: "Writefull's Paraphraser gives you alternative ways of writing something.",
      path: '/paraphraser',
      icon: <FontAwesomeIcon icon={faTransformAi} size='xl' />,
      element: <Paraphraser />,
    },
    {
      name: 'Academizer',
      title: 'Turn informal into academic.',
      subtitle:
        "Writefull's Academizer makes your informal sentence appropriate for an academic text.",
      path: '/academizer',
      icon: <FontAwesomeIcon icon={faGraduationCap} size='xl' />,
      element: <Academizer />,
    },
  ]

  const pages: (Page | NonVisiblePage)[] = [
    {
      name: 'Writefull X',
      title: 'Elevate your writing with Writefull',
      subtitle: (
        <div>
          Most of these widgets are also available in{' '}
          <a className='underline' href='https://www.writefull.com/writefull-for-word'>
            Writefull for Word
          </a>{' '}
          or{' '}
          <a className='underline' href='https://www.writefull.com/writefull-for-overleaf'>
            for Overleaf
          </a>
          .
          <div className='pt-1'>
            <a
              href='https://writefull.typeform.com/api-request'
              target='_blank'
              rel='noreferrer'
              className='underline'
            >
              Request API access
            </a>{' '}
            to use these services programmatically.
          </div>
        </div>
      ),
      path: '/',
      icon: <FontAwesomeIcon icon={faHouse} size='xl' />,
      element: <Home features={features} />,
    },
    {
      path: '/gpt-detector',
      element: <GPTDetector />,
      title: 'GPT Detector',
      subtitle: 'Our GPT Detector has been discontinued',
      name: 'GPT Detector',
    },
    ...features,
  ]

  return pages
}
